import {AfterViewInit, Component, OnInit, ViewChild, ViewChildren} from "@angular/core";
import {AuthenticationService} from "src/app/services";
import {Role} from "src/app/models";
import {Claim} from "src/app/models/account";
import {NetworkService, DocumentRpcService, NetworkResponse} from '@alpha/services';
import {ModalComponent} from '@alpha/ui';

@Component({
  selector: "template-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit, AfterViewInit {
  Role = Role;
  role: Role;
  name: string;
  user_id: string;
  isAlpha: boolean;
  @ViewChildren(ModalComponent) network_modal: ModalComponent[] | undefined;

  constructor(private _as: AuthenticationService, private doc: DocumentRpcService, private network: NetworkService) {
    this.role = this._as.getClaim(Claim.Role);
    this.name = this._as.getClaim(Claim.Name);
    this.user_id = this._as.getClaim(Claim.ID);
    this.isAlpha = (this.role == Role.Alpha || this.role == Role.Manager || this.role == Role.Clerk);
  }

  networkCheck(status: NetworkResponse, scope: DashboardComponent) {
    const modal = this.network_modal?.find(e=>e.heading.indexOf("Network") != -1);
    if (scope.network_modal && modal) {
      modal.active = !status.status;
      if (status.status) {
        window.location.reload();
      }
    }
  }

  ngAfterViewInit() {
    this.network.connection.subscribe((status: NetworkResponse) => this.networkCheck(status, this));
    this.network.version.subscribe((res: NetworkResponse) => this.handleVersion(res));
  }

  handleVersion(res: NetworkResponse) {
    const modal = this.network_modal?.find(e=>e.heading.indexOf("Version") != -1);
    if(modal){
      const version = localStorage.getItem('version');
      if (version != res.version!.frontend! && version != null) {
        localStorage.clear();
        modal.active = true;
      }
      localStorage.setItem('version', res.version!.frontend!);
    }


  }

  async ngOnInit() {
    const win: any = window;

    if (win.DD_RUM) {
      win.DD_RUM.setUser({
        id: this.user_id ?? "Anonymous User",
        name: this.name ?? "Anonymous User"
      });
    }

  }
}
